import { createIcon } from '@chakra-ui/icon'

const FreePlanGraphic = createIcon({
  viewBox: '0 0 294.287 217.747',
  path: (
    <g>
      <defs>
        <style>
          {'.cls-5{fill:#fdb400}.cls-6{fill:#263238}.cls-8{fill:#4c91f3}'}
        </style>
      </defs>
      <g data-name="In sync-rafiki" transform="translate(-56.11 -100.59)">
        <g transform="translate(73.062 100.59)">
          <path
            data-name="Path 21973"
            d="M344.1 202.338c-4.86-11.54-22.1-26-35.446-28.57-17.052-3.293-23.413 7.463-37.789 8.08-38.819 1.646-58.91-26.22-82.9-50.511-53.158-53.847-135-13.418-97.663 62.2 22.441 45.455 90.664 108.7 140.478 51.5 21.52-24.719 8.892-34.866 45.2-21.941 14.329 5.092 90.145 31.53 68.12-20.758z"
            transform="translate(-80.861 -106.667)"
            fill="#407bff"
          />
          <path
            data-name="Path 21974"
            d="M344.1 202.338c-4.86-11.54-22.1-26-35.446-28.57-17.052-3.293-23.413 7.463-37.789 8.08-38.819 1.646-58.91-26.22-82.9-50.511-53.158-53.847-135-13.418-97.663 62.2 22.441 45.455 90.664 108.7 140.478 51.5 21.52-24.719 8.892-34.866 45.2-21.941 14.329 5.092 90.145 31.53 68.12-20.758z"
            transform="translate(-80.861 -106.667)"
            fill="#dcf9ee"
          />
        </g>
        <g transform="translate(56.11 301.916)">
          <ellipse
            cx="140.631"
            cy="8.211"
            rx="140.631"
            ry="8.211"
            fill="#f5f5f5"
          />
        </g>
        <g transform="translate(224.482 118.49)" opacity=".84">
          <path
            data-name="Path 21728"
            className="cls-5"
            d="M98.594 407.656a13.046 13.046 0 0 0-1.447-10.066 22.922 22.922 0 0 0-7.289-7.375c-5.606-3.762-13.227-5.252-19.959-5.6.1 7.5 5.8 14.053 8.9 17.151 4.909 4.973 16.786 10.977 19.8 5.842"
            transform="translate(-26.296 -240.901)"
          />
          <path
            data-name="Path 21729"
            className="cls-5"
            d="M80.87 373.961a11.062 11.062 0 0 0 10.344 4.095 14.686 14.686 0 0 0 9.647-6.067c1.072-1.458 1.919-3.269 1.458-5.017a4.716 4.716 0 0 0-3.612-3.162 9.519 9.519 0 0 0-4.974.439c-5.5 1.737-10.516 4.427-12.863 9.712"
            transform="translate(-41.48 -242.408)"
          />
          <path
            data-name="Path 21730"
            className="cls-6"
            d="M89.159 366a8.1 8.1 0 0 0 1.179.74l3.28 1.9a38.969 38.969 0 0 0 11.62 4.76 23.668 23.668 0 0 0 12.434-.622 16.083 16.083 0 0 0 3.43-1.651c.386-.236.654-.461.847-.6s.279-.225.268-.236a26.451 26.451 0 0 1-4.652 2.144 24.748 24.748 0 0 1-12.231.472 41.991 41.991 0 0 1-11.48-4.609c-1.4-.74-2.551-1.351-3.344-1.747a7.5 7.5 0 0 0-1.351-.551z"
            transform="translate(-70.136 -242.24)"
          />
          <path
            data-name="Path 21731"
            className="cls-6"
            d="M123.755 403.669a2.7 2.7 0 0 0-.407-.45c-.332-.3-.74-.7-1.254-1.19-1.072-1.072-2.691-2.508-4.674-4.288-3.988-3.612-9.551-8.575-15.822-13.806s-12.048-9.948-16.283-13.249c-2.144-1.662-3.837-2.991-5.049-3.891l-1.383-1.072a3.266 3.266 0 0 0-.515-.332 2.534 2.534 0 0 0 .45.418l1.329 1.072 4.952 4.009c4.17 3.376 9.915 8.071 16.186 13.356s11.866 10.151 15.9 13.689l4.824 4.234 1.308 1.125a3.45 3.45 0 0 0 .438.375z"
            transform="translate(-60.107 -242.284)"
          />
          <path
            data-name="Path 21732"
            className="cls-5"
            d="M109.784 377.767a25.919 25.919 0 0 1 5.3 23.079c-.536 2.026-1.683 4.288-3.752 4.556s-3.773-1.629-4.77-3.473a22.146 22.146 0 0 1 2.723-24.419"
            transform="translate(-79.794 -241.412)"
          />
          <path
            data-name="Path 21733"
            className="cls-6"
            d="M117.876 396.767a6.437 6.437 0 0 0 .386-1.254 12.7 12.7 0 0 0 .322-1.5c.086-.589.247-1.254.3-2a21.745 21.745 0 0 0 .139-2.466 25.731 25.731 0 0 0-.086-2.83 28.946 28.946 0 0 0-1.319-6.357 28.542 28.542 0 0 0-2.83-5.853 22.067 22.067 0 0 0-1.672-2.283 20.533 20.533 0 0 0-1.64-1.844 18.863 18.863 0 0 0-1.49-1.393 10.714 10.714 0 0 0-1.19-.954 5.9 5.9 0 0 0-1.072-.729c-.075.086 1.469 1.147 3.516 3.312a22.213 22.213 0 0 1 1.576 1.855 27.307 27.307 0 0 1 1.608 2.283 29.041 29.041 0 0 1 2.733 5.767 29.925 29.925 0 0 1 1.34 6.239c.075.975.15 1.908.129 2.787a21.85 21.85 0 0 1-.086 2.433c-.256 2.965-.76 4.766-.664 4.787z"
            transform="translate(-86.847 -242.147)"
          />
          <path
            data-name="Path 21734"
            d="M29.379 354.7c-13.828-19.048-9.8-44.121-1.726-65.13 1.351-3.505 2.251-7.386 5.017-9.915s7.439-3.291 10.1-.7c2.208 2.144 2.294 5.606 2.894 8.651a21.953 21.953 0 0 0 5.574 10.827c1.854 1.951 4.406 3.645 7.064 3.216 3.645-.632 5.467-4.738 6.667-8.275l6.689-19.831c1.2-3.537 2.433-7.139 4.7-10.108s5.756-5.242 9.433-5.027 7.163 3.592 6.681 7.292a34.306 34.306 0 0 1-1.426 4.427c-.407 1.5-.279 3.366.965 4.288s3.023.386 4.438-.289c4.877-2.3 8.929-6.035 12.863-9.8s7.75-7.675 12.4-10.408 10.28-4.288 15.436-2.787 9.454 6.432 9.015 11.791-5.081 9.465-9.647 12.4a83.4 83.4 0 0 1-21.835 10.012 6.9 6.9 0 0 0-3.762 2c-1.586 2.09-.161 5.2 1.9 6.775 2.326 1.779 5.274 2.5 7.911 3.773s5.2 3.516 5.36 6.432c.193 4.116-4.127 6.85-7.954 8.3a71.4 71.4 0 0 1-23.957 4.631c-2.926.054-5.949-.064-8.672 1.072s-5.081 3.837-4.674 6.753 3.377 4.845 6.271 5.284 5.831-.2 8.768-.278c5.478-.161 11.63 2.347 13.281 7.611a11.723 11.723 0 0 1-2.219 10.291 27.391 27.391 0 0 1-8.372 6.871 71.817 71.817 0 0 1-36.017 10.344c-12.6 0-23.389-2.54-33.155-10.494"
            transform="translate(-20.281 -250.545)"
            fill="#2fbc87"
          />
          <path
            data-name="Path 21735"
            className="cls-6"
            d="M23.54 360.71c3.677-8.157 4.116-8.2 10.976-17.826a335.009 335.009 0 0 1 24.322-29.714l6.775-7.45c2.23-2.444 4.438-4.866 6.753-7.107a166.552 166.552 0 0 1 14-12.092c4.641-3.634 9.176-6.9 13.442-9.937s8.307-5.767 12.091-8.114a132.363 132.363 0 0 1 18.662-9.722c2.283-.965 4.073-1.662 5.306-2.144l1.393-.514.482-.15a2.693 2.693 0 0 1-.461.214l-1.372.579c-1.2.493-2.98 1.233-5.252 2.241a139.654 139.654 0 0 0-18.512 9.894c-3.752 2.369-7.761 5.124-12.016 8.168s-8.758 6.335-13.378 9.964a169.8 169.8 0 0 0-13.935 12.07c-2.294 2.229-4.481 4.631-6.71 7.085l-6.775 7.5A342.343 342.343 0 0 0 35.02 343.27c-6.871 9.583-7.332 9.562-11.052 17.665"
            transform="translate(-15.321 -250.157)"
          />
          <path
            data-name="Path 21736"
            className="cls-6"
            d="M76.59 298.515a8.234 8.234 0 0 1 .171-1.629c.15-1.072.429-2.54.783-4.384.718-3.677 1.876-8.736 3.216-14.31s2.39-10.634 3.044-14.321c.332-1.844.59-3.334.75-4.373a8.238 8.238 0 0 1 .332-1.6 6.976 6.976 0 0 1-.064 1.629c-.086 1.072-.268 2.562-.536 4.416-.536 3.72-1.554 8.822-2.862 14.4s-2.476 10.473-3.377 14.267c-.386 1.715-.718 3.216-.986 4.288a7.914 7.914 0 0 1-.471 1.617z"
            transform="translate(-19.353 -250.016)"
          />
          <path
            data-name="Path 21737"
            className="cls-6"
            d="M87.559 303a11.194 11.194 0 0 1-1.876-.407c-1.2-.3-2.937-.74-5.1-1.222-4.288-.986-10.312-2.144-16.99-3.13s-12.767-1.6-17.151-1.919c-2.208-.182-4-.279-5.231-.354a10.823 10.823 0 0 1-1.919-.172 9.14 9.14 0 0 1 1.93-.1c1.243 0 3.044 0 5.252.129 4.438.2 10.558.75 17.258 1.726a167.46 167.46 0 0 1 17 3.344c2.144.536 3.87 1.072 5.059 1.437a10.007 10.007 0 0 1 1.769.665z"
            transform="translate(17.98 -247.298)"
          />
          <path
            data-name="Path 21738"
            className="cls-6"
            d="M121.894 340.869a2.582 2.582 0 0 1-.118-.665c-.064-.514-.129-1.147-.214-1.908-.171-1.662-.364-4.063-.557-7.043-.386-5.96-.675-14.2-.857-23.293s-.4-17.344-.665-23.293c-.139-2.9-.257-5.284-.343-7.053a14.339 14.339 0 0 0-.075-1.919 2.056 2.056 0 0 1 0-.675 2.588 2.588 0 0 1 .118.665c0 .514.118 1.136.2 1.908.171 1.651.364 4.062.557 7.042.4 5.949.675 14.192.868 23.3s.4 17.333.654 23.283c.139 2.894.257 5.285.343 7.053a14.313 14.313 0 0 0 .075 1.919 2.979 2.979 0 0 1 .014.679z"
            transform="translate(-101.853 -248.784)"
          />
          <path
            data-name="Path 21739"
            className="cls-6"
            d="M123.547 337.868a3 3 0 0 1-.686 0H120.9l-7.171-.139c-6.067-.118-14.439-.182-23.7-.246s-17.644-.2-23.7-.44a245.95 245.95 0 0 1-7.171-.364l-1.951-.15a2.79 2.79 0 0 1-.675-.1 3.1 3.1 0 0 1 .686 0h1.951l7.182.139c6.056.118 14.439.182 23.689.246s17.644.193 23.7.439c3.034.118 5.488.236 7.182.365l1.94.139a2.138 2.138 0 0 1 .685.111z"
            transform="translate(-36.488 -244.368)"
          />
        </g>
        <g transform="translate(74.334 106.354)">
          <path
            data-name="Path 23081"
            className="cls-8"
            d="M122.405 64a58.405 58.405 0 1 0 58.405 58.405A58.409 58.409 0 0 0 122.405 64zm0 106.9a48.5 48.5 0 1 1 48.5-48.5 48.506 48.506 0 0 1-48.5 48.5z"
          />
          <path
            data-name="Path 23082"
            d="M426.6 356.644c0 3.311 2.047 5.88 6.453 7.47a19.071 19.071 0 0 0 1.956.652V348.6c-4.824.613-8.409 3.311-8.409 8.044zm15.188 17.626a14.34 14.34 0 0 1-1.147-.287v17.43c5.554-.5 9.387-3.559 9.387-8.656-.001-4.003-2.074-6.61-8.24-8.487z"
            transform="translate(-315.328 -247.497)"
            fill="#f1f6fe"
          />
          <path
            data-name="Path 23083"
            d="M188.5 140a48.5 48.5 0 1 0 48.5 48.5 48.506 48.506 0 0 0-48.5-48.5zm2.92 76.813.026 4.133A1.049 1.049 0 0 1 190.4 222h-3.7a1.046 1.046 0 0 1-1.043-1.043v-4.094c-11.6-.847-17.039-7.444-17.626-14.614a1.045 1.045 0 0 1 1.043-1.134h6.026a1.038 1.038 0 0 1 1.03.86c.665 4.146 3.9 7.222 9.66 7.992v-18.6l-3.22-.821c-6.818-1.63-13.311-5.88-13.311-14.693 0-9.517 7.222-14.614 16.453-15.514v-4.3a1.046 1.046 0 0 1 1.043-1.043h3.663a1.046 1.046 0 0 1 1.043 1.043v4.261c8.93.9 15.618 6.114 16.413 14.236a1.056 1.056 0 0 1-1.043 1.147h-5.854a1.029 1.029 0 0 1-1.03-.9c-.521-3.807-3.585-6.91-8.539-7.587V184.7l3.311.769c8.448 2.086 14.2 6.127 14.21 15.175-.003 9.807-7.304 15.27-17.511 16.169z"
            transform="translate(-66.092 -66.092)"
            fill="#edf4fe"
          />
          <path
            data-name="Path 23084"
            className="cls-8"
            d="m381.661 285.48-3.311-.769V267.2c4.954.678 8.018 3.781 8.539 7.587a1.029 1.029 0 0 0 1.03.9h5.854a1.056 1.056 0 0 0 1.043-1.147c-.8-8.122-7.483-13.337-16.413-14.236v-4.263a1.046 1.046 0 0 0-1.044-1.041H373.7a1.046 1.046 0 0 0-1.043 1.043v4.3c-9.23.9-16.453 6-16.453 15.514 0 8.813 6.492 13.063 13.311 14.693l3.22.821v18.6c-5.762-.769-9-3.846-9.66-7.992a1.038 1.038 0 0 0-1.03-.86h-6.023a1.045 1.045 0 0 0-1.043 1.134c.587 7.17 6.023 13.767 17.626 14.614v4.094a1.046 1.046 0 0 0 1.043 1.043h3.7a1.049 1.049 0 0 0 1.043-1.056l-.026-4.133c10.208-.9 17.509-6.362 17.509-16.166-.016-9.041-5.765-13.083-14.213-15.169zm-8.943-2.112a19.057 19.057 0 0 1-1.956-.652c-4.406-1.59-6.453-4.159-6.453-7.47 0-4.732 3.585-7.431 8.409-8.044zm5.632 26.647v-17.43c.4.117.769.209 1.147.287 6.166 1.877 8.239 4.485 8.239 8.487 0 5.098-3.836 8.161-9.387 8.657z"
            transform="translate(-253.037 -166.1)"
          />
        </g>
      </g>
    </g>
  ),
})

export default FreePlanGraphic
